module.exports = __webpack_public_path__ + "static/media/teams.ac1e7df3.jpg";